import { put, takeLatest, call, all } from 'redux-saga/effects'
import callAny from './helpers/call_any'
import actionTypes from '../actions/actionTypes'
import { userSync } from 'sync'
import overlayTypes from 'helpers/enums/overlayTypes'
import confirmTypes from 'helpers/enums/confirmTypes'
import actionUserTypes from 'helpers/enums/actionUserTypes'
import buttonUserTypes from 'helpers/enums/buttonUserTypes'
import myLibraryActions from 'redux/actions/my_library_actions'
import formatError from './helpers/error_formatter'
import generalActions from 'redux/actions/generalActions'
import nickelTourActions from 'redux/actions/nickelTourActions'

function *notificationButtonConfirm(notificationType, buttonType, actionType, presentationId = 0) {
	try {
		yield all([
			callAny(userSync.loginNotification, notificationType, buttonType, actionType, presentationId),
			callAny(userSync.trackUserAction, {feature: notificationType, button: buttonType, action: actionType}),
		])
	} catch (error) {
		// throw error
	}
}

function *overlaySchoolLibraryOnboardingConfirm() {
	yield call(notificationButtonConfirm, overlayTypes.FEATURE_SL_ONBOARDING_OVERLAY_ID, buttonUserTypes.BUTTON_GOT_IT_CONTINUE, actionUserTypes.ACTION_CONTINUE)
}

function *overlayDistrictLibraryOnboardingConfirm() {
	yield call(notificationButtonConfirm, overlayTypes.FEATURE_DL_ONBOARDING_OVERLAY_ID, buttonUserTypes.BUTTON_GOT_IT_CONTINUE, actionUserTypes.ACTION_CONTINUE)
}

function *overlaySubsDismiss() {
	yield call(notificationButtonConfirm, overlayTypes.FEATURE_SUBS_OVERLAY_ID, buttonUserTypes.BUTTON_NO_THANKS, actionUserTypes.ACTION_CANCEL)
}

function *overlaySubsConfirm(action) {
	let actionUserType, buttonUserType
	if (action.hasVisitedSubplans) {
		actionUserType = actionUserTypes.ACTION_SUBS_DASHBOARD
		buttonUserType = buttonUserTypes.BUTTON_SUBS_GO_TO_DASHBOARD
	} else {
		actionUserType = actionUserTypes.ACTION_CONTINUE
		buttonUserType = buttonUserTypes.BUTTON_LEARN_MORE
	}
	yield call(notificationButtonConfirm, overlayTypes.FEATURE_SUBS_OVERLAY_ID, buttonUserType, actionUserType)

}

function *featureRedeemFailConfirm() {
	yield call(notificationButtonConfirm, confirmTypes.FEATURE_REDEEM_FAIL_ID, buttonUserTypes.BUTTON_GOT_IT_CONTINUE, actionUserTypes.ACTION_CONTINUE)
}

function *overlaySchoolUserOnboardingConfirm() {
	try {
		yield call(notificationButtonConfirm, overlayTypes.FEATURE_SCHOOL_USER_ONBOARDING_OVERLAY_ID, buttonUserTypes.BUTTON_CONTINUE, actionUserTypes.ACTION_CONTINUE)
		yield put(myLibraryActions.schoolFreeTrialUserOnboardingOverlayConfirmSuccess())
	} catch (error) {
		const serverError = formatError(error)
		yield put(myLibraryActions.schoolFreeTrialOnboardingOverlayFailed(serverError))
	}
}

function *confirmPaywallExpiredUpgrade() {
	yield call(notificationButtonConfirm, confirmTypes.FEATURE_PAYWALLS_EXPIRED_ID, buttonUserTypes.BUTTON_GOT_IT_CONTINUE, actionUserTypes.ACTION_CONTINUE)
}

function *confirmPaywallExpiredClose() {
	yield call(notificationButtonConfirm, confirmTypes.FEATURE_PAYWALLS_EXPIRED_ID, buttonUserTypes.BUTTON_NO_THANKS, actionUserTypes.ACTION_CANCEL)
}

function *confirmPaywallReminderUpgrade() {
	yield call(notificationButtonConfirm, confirmTypes.FEATURE_PAYWALLS_REMINDER_ID, buttonUserTypes.BUTTON_GOT_IT_CONTINUE, actionUserTypes.ACTION_CONTINUE)
}

function *confirmPaywallReminderClose() {
	yield call(notificationButtonConfirm, confirmTypes.FEATURE_PAYWALLS_REMINDER_ID, buttonUserTypes.BUTTON_NO_THANKS, actionUserTypes.ACTION_CANCEL)
}

function *onboardingCreateLessonOverlayConfirm() {
	yield call(notificationButtonConfirm, overlayTypes.FEATURE_OB_LESS_CREATE_OVERLAY_ID, buttonUserTypes.BUTTON_CONTINUE, actionUserTypes.ACTION_CONTINUE)
}

function *onboardingCreateLessonOverlayDismiss() {
	yield call(notificationButtonConfirm, overlayTypes.FEATURE_OB_LESS_CREATE_OVERLAY_ID, buttonUserTypes.BUTTON_NO_THANKS, actionUserTypes.ACTION_CANCEL)
}

function *overlaySchoolTrialOnboardingConfirm() {
	try {
		yield callAny(userSync.loginNotification,
			overlayTypes.FEATURE_SCHOOL_TRIAL_ONBOARDING_OVERLAY_ID,
			buttonUserTypes.BUTTON_CONTINUE,
			actionUserTypes.ACTION_CONTINUE
		)
		yield put(myLibraryActions.overlaySchoolTrialOnboardingConfirmSuccess())
	} catch (error) {
		const serverError = formatError(error)
		yield put(myLibraryActions.schoolFreeTrialOnboardingOverlayFailed(serverError))
	}
}

function *overlaySchoolUserOnboardingDismiss() {
	try {
		yield call(notificationButtonConfirm, overlayTypes.FEATURE_SCHOOL_USER_ONBOARDING_OVERLAY_ID, buttonUserTypes.BUTTON_NO_THANKS, actionUserTypes.ACTION_CANCEL)
	} catch (error) {

	}
}

function *overlaySchoolTrialOnboardingDismiss() {
	try {
		yield call(notificationButtonConfirm, overlayTypes.FEATURE_SCHOOL_TRIAL_ONBOARDING_OVERLAY_ID, buttonUserTypes.BUTTON_NO_THANKS, actionUserTypes.ACTION_CANCEL)
	} catch (error) {

	}
}

function *myLibrarySchoolJoinConfirmClose() {
	yield call(notificationButtonConfirm, confirmTypes.FEATURE_SCHOOL_JOINED_NOTIFICATION, buttonUserTypes.BUTTON_GOT_IT_CONTINUE, actionUserTypes.ACTION_CONTINUE)
}

function *myLibrarySchoolInviteConfirmYes() {
	try {
		yield call(notificationButtonConfirm, confirmTypes.FEATURE_SCHOOL_INVITED_NOTIFICATION, buttonUserTypes.BUTTON_CONTINUE, actionUserTypes.ACTION_CONTINUE)
		yield put(myLibraryActions.schoolInviteConfirmYesSuccess())
	} catch (error) {

	}
}

function *myLibrarySchoolInviteConfirmDismiss() {
	yield call(notificationButtonConfirm, confirmTypes.FEATURE_SCHOOL_INVITED_NOTIFICATION, buttonUserTypes.BUTTON_NO_THANKS, actionUserTypes.ACTION_CANCEL)
}

function *myLibrarySchoolInviteNoSlotsClose() {
	yield call(notificationButtonConfirm, confirmTypes.FEATURE_SCHOOL_JOINED_NO_SLOTS_NOTIFICATION, buttonUserTypes.BUTTON_GOT_IT_CANCEL, actionUserTypes.ACTION_CANCEL)
}

function *myLibraryTimeToClimbCancelled() {
	try {
		yield callAny(userSync.loginNotification,
			overlayTypes.FEATURE_TIME_TO_CLIMB_OVERLAY_ID,
			null,
			actionUserTypes.ACTION_CANCEL)
	} catch (error) {
		yield put(generalActions.syncUncaughtError())
	}
}

function *myLibraryTimeToClimbExplore() {
	try {
		const response = yield callAny(userSync.loginNotification,
			overlayTypes.FEATURE_TIME_TO_CLIMB_OVERLAY_ID,
			null,
			actionUserTypes.ACTION_CONTINUE)
		yield put(myLibraryActions.timeToClimbSuccess(response.payload.timeToClimbAuthor))
	} catch (error) {
		yield put(generalActions.syncUncaughtError())
	}
}

function *myLibraryFlocabularyAnnouncementConfirmed() {
	yield call(notificationButtonConfirm, overlayTypes.FEATURE_FLOCABULARY_ANNOUNCEMENT_OVERLAY_ID, buttonUserTypes.BUTTON_GOT_IT_CONTINUE, actionUserTypes.ACTION_CONTINUE)
}

function *flocabularyWarningOverlayFinished() {
	yield call(notificationButtonConfirm, overlayTypes.FEATURE_FLOCABULARY_RESTRICTION_WARNING_ID, buttonUserTypes.NO_BUTTON, actionUserTypes.ACTION_AUTO_DISMISS)
}

function *myLibraryImmersiveReaderCancelled() {
	try {
		yield callAny(userSync.loginNotification,
			overlayTypes.FEATURE_IMMERSIVE_READER_OVERLAY_ID,
			null,
			actionUserTypes.ACTION_CANCEL)
	} catch (error) {
		yield put(generalActions.syncUncaughtError())
	}
}

function *myLibraryImmersiveReaderConfirmed() {
	try {
		const response = yield callAny(userSync.loginNotification,
			overlayTypes.FEATURE_IMMERSIVE_READER_OVERLAY_ID,
			null,
			actionUserTypes.ACTION_CONTINUE)
		yield put(myLibraryActions.immersiveReaderSuccess(response.payload.redirectUrl))
	} catch (error) {
		yield put(generalActions.syncUncaughtError())
	}
}

function *nickelTourOverlayClosed() {
	try {
		yield callAny(userSync.loginNotification,
			overlayTypes.FEATURE_NICKEL_TOUR_OVERLAY_ID,
			null,
			actionUserTypes.ACTION_CANCEL)
	} catch (error) {
		const serverError = formatError(error)
		yield put(nickelTourActions.notificationCloseFailed(serverError))
	}
}

function *nickelTourOverlayCompleted() {
	try {
		yield callAny(userSync.loginNotification,
			overlayTypes.FEATURE_NICKEL_TOUR_OVERLAY_ID,
			null,
			actionUserTypes.ACTION_CONTINUE)
	} catch (error) {
		const serverError = formatError(error)
		yield put(nickelTourActions.notificationCompleteFailed(serverError))
	}
}

export default [
	takeLatest(actionTypes.OVERLAY_DISTRICT_LIBRARY_ONBOARDING_CONFIRM, overlayDistrictLibraryOnboardingConfirm),
	takeLatest(actionTypes.OVERLAY_SCHOOL_LIBRARY_ONBOARDING_CONFIRM, overlaySchoolLibraryOnboardingConfirm),
	takeLatest(actionTypes.MY_LIBRARY_ONBOARDING_CREATE_LESSON_OVERLAY_CONFIRM, onboardingCreateLessonOverlayConfirm),
	takeLatest(actionTypes.MY_LIBRARY_ONBOARDING_CREATE_LESSON_OVERLAY_DISMISS, onboardingCreateLessonOverlayDismiss),
	takeLatest(actionTypes.MY_LIBRARY_SUBS_OVERLAY_DISMISS, overlaySubsDismiss),
	takeLatest(actionTypes.MY_LIBRARY_SUBS_OVERLAY_LEARN_MORE, overlaySubsConfirm),
	takeLatest(actionTypes.MY_LIBRARY_FEATURE_REDEEM_FAIL_CONFIRM, featureRedeemFailConfirm),
	takeLatest(actionTypes.MY_LIBRARY_SCHOOL_USER_ONBOARDING_OVERLAY_CONFIRM, overlaySchoolUserOnboardingConfirm),
	takeLatest(actionTypes.MY_LIBRARY_SCHOOL_USER_ONBOARDING_OVERLAY_DISMISS, overlaySchoolUserOnboardingDismiss),
	takeLatest(actionTypes.MY_LIBRARY_PAYWALL_EXPIRED_UPGRADE, confirmPaywallExpiredUpgrade),
	takeLatest(actionTypes.MY_LIBRARY_PAYWALL_EXPIRED_CLOSE, confirmPaywallExpiredClose),
	takeLatest(actionTypes.MY_LIBRARY_PAYWALL_REMINDER_UPGRADE, confirmPaywallReminderUpgrade),
	takeLatest(actionTypes.MY_LIBRARY_PAYWALL_REMINDER_CLOSE, confirmPaywallReminderClose),
	takeLatest(actionTypes.MY_LIBRARY_SCHOOL_TRIAL_ONBOARDING_OVERLAY_CONFIRM, overlaySchoolTrialOnboardingConfirm),
	takeLatest(actionTypes.MY_LIBRARY_SCHOOL_TRIAL_ONBOARDING_OVERLAY_DISMISS, overlaySchoolTrialOnboardingDismiss),
	takeLatest(actionTypes.MY_LIBRARY_SCHOOL_JOIN_CONFIRM_CLOSE, myLibrarySchoolJoinConfirmClose),
	takeLatest(actionTypes.MY_LIBRARY_SCHOOL_INVITE_CONFIRM_YES, myLibrarySchoolInviteConfirmYes),
	takeLatest([actionTypes.MY_LIBRARY_SCHOOL_INVITE_CONFIRM_NO, actionTypes.MY_LIBRARY_SCHOOL_INVITE_CONFIRM_CLOSE], myLibrarySchoolInviteConfirmDismiss),
	takeLatest(actionTypes.MY_LIBRARY_SCHOOL_INVITE_CONFIRM_NOSLOTS_CLOSE, myLibrarySchoolInviteNoSlotsClose),
	takeLatest(actionTypes.MY_LIBRARY_TIME_TO_CLIMB_EXPLORE, myLibraryTimeToClimbExplore),
	takeLatest(actionTypes.MY_LIBRARY_TIME_TO_CLIMB_CANCELLED, myLibraryTimeToClimbCancelled),
	takeLatest(actionTypes.MY_LIBRARY_FLOCABULARY_ANNOUNCEMENT_CONTINUE_SELECTED, myLibraryFlocabularyAnnouncementConfirmed),
	takeLatest(actionTypes.FLOCABULARY_WARNING_OVERLAY_FINISHED, flocabularyWarningOverlayFinished),
	takeLatest(actionTypes.MY_LIBRARY_IMMERSIVE_READER_CANCELLED, myLibraryImmersiveReaderCancelled),
	takeLatest(actionTypes.MY_LIBRARY_IMMERSIVE_READER_CONFIRMED, myLibraryImmersiveReaderConfirmed),
	takeLatest(actionTypes.NICKEL_TOUR_CLOSE, nickelTourOverlayClosed),
	takeLatest(actionTypes.NICKEL_TOUR_COMPLETED, nickelTourOverlayCompleted),
]

export {
	myLibraryTimeToClimbCancelled,
	myLibraryTimeToClimbExplore,
	overlaySchoolTrialOnboardingConfirm,
	overlaySchoolUserOnboardingConfirm,
	myLibraryFlocabularyAnnouncementConfirmed,
	flocabularyWarningOverlayFinished,
	myLibraryImmersiveReaderCancelled,
	myLibraryImmersiveReaderConfirmed,
	nickelTourOverlayClosed,
}
